import { AddMembersModalPage, AddMembersModalPageProps } from '@/components'

export function AddMembers(props: AddMembersModalPageProps) {

  return (
    <AddMembersModalPage
      {...props}
      buttonProps={{
        text: 'Next',
      }}
    />
  )
}
